// extracted by mini-css-extract-plugin
export default {"image":"background__image__FcgKK","color":"background__color__DtQkE","video":"background__video__cBUzW","videoEnabled":"background__videoEnabled__hiHFG"};